<div class="edp-banner-app">
    <div class="d-flex align-items-center">
        <img class="edp-banner-app__logo" src="./assets/images/stella-images/edp_small_dark_logo.png" alt="EDP Zero" />
        <div class="edp-banner-app__info">
            <div class="edp-banner-app__title">{{ "pt.edp.edponline.appBanner.appName" | translate }}</div>
            <div class="edp-banner-app__description">{{ "pt.edp.edponline.appBanner.appDescription" | translate }}</div>
        </div>
    </div>
    <button class="btn edp-text-electric-green edp-banner-app__button text-decoration-none" [edpExternalLink]="storeLink">
        {{ "pt.edp.edponline.appBanner.goToApp" | translate }}
        <i class="icon-edponline-Bop-073 rotate-270"></i>
    </button>
</div>
